import React, { FunctionComponent, HTMLAttributes } from 'react';
import clsx from 'clsx';
import Icon from '~/components/Icon';
import usePopoverMenuItem from './usePopoverMenuItem';
import type { PopoverMenuItemSize } from '~/components/PopoverMenu/types';
import { useButtonTracking } from '~/hooks';
import type { PopoverMenuItemSelectedColorVariant } from './types';

export interface PopoverMenuItemProps
  extends HTMLAttributes<HTMLButtonElement | HTMLDivElement> {
  name: string;
  icon: string;
  size?: PopoverMenuItemSize;
  arrow?: boolean;
  selected?: boolean;
  seperator?: boolean;
  selectedColorVariant?: PopoverMenuItemSelectedColorVariant;
}

const PopoverMenuItem: FunctionComponent<PopoverMenuItemProps> = function ({
  name,
  icon,
  size = 'small',
  arrow = false,
  selected = false,
  onClick: inputOnClick,
  className,
  selectedColorVariant = 'default',
  ...restProps
}) {
  const { classNames, iconProps, arrowIconProps } = usePopoverMenuItem(
    size,
    selected,
    selectedColorVariant,
  );

  const id = `popover-menu-item-${name.toLowerCase().replace(/ /g, '-')}`;

  const { onClick } = useButtonTracking(id, inputOnClick);

  return (
    <button
      id={id}
      className={clsx(classNames.container, className)}
      onClick={onClick}
      {...restProps}
    >
      <Icon
        icon={icon}
        {...iconProps}
        stroke={iconProps.stroke || classNames.icon}
      />
      <div className={classNames.name}>{name}</div>
      {arrow && <Icon {...arrowIconProps} />}
    </button>
  );
};

export default PopoverMenuItem;
